import React from "react";
import { AlertTriangle } from "lucide-react";
import { SOCIALS, ROOBET_LINK } from "../mock";

const Footer = () => {
  return (
    <footer className="relative bg-[#251e44] border-t border-[#473c7d] pt-14 pb-8 px-5">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 pb-10 border-b border-[#473c7d]">
          <div className="flex items-center gap-3">
            <img src="/assets/broer-logo.png" alt="Broer" className="h-12 w-12 rounded-full object-cover ring-2 ring-[#edbb23]" />
            <div>
              <p className="text-2xl font-black text-white leading-none">BROER</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <a href={SOCIALS.kick} target="_blank" rel="noopener noreferrer" className="w-11 h-11 rounded-xl bg-[#342b60] border border-[#473c7d] flex items-center justify-center hover:bg-[#5b5baf]/25 transition-colors"><img src="/assets/kick-white.png" alt="Kick" className="w-5 h-5 object-contain" /></a>
            <a href={SOCIALS.discord} target="_blank" rel="noopener noreferrer" className="w-11 h-11 rounded-xl bg-[#342b60] border border-[#473c7d] flex items-center justify-center hover:bg-[#5b5baf]/25 transition-colors"><img src="/assets/discord-white.png" alt="Discord" className="w-5 h-5 object-contain" /></a>
            <a href={SOCIALS.x} target="_blank" rel="noopener noreferrer" className="w-11 h-11 rounded-xl bg-[#342b60] border border-[#473c7d] flex items-center justify-center hover:bg-[#5b5baf]/25 transition-colors"><img src="/assets/x-white.png" alt="X" className="w-4 h-4 object-contain" /></a>
          </div>
        </div>

        <div className="flex items-start gap-3 mt-8 text-[#8f88b8] text-xs leading-relaxed max-w-3xl">
          <AlertTriangle size={16} className="text-[#edbb23] shrink-0 mt-0.5" />
          <p>
            Gambling can be addictive. Play responsibly and only bet what you can afford to lose. 18+ only.
            Broer is a community website and is not a gambling operator. Playing via{" "}
            <a href={ROOBET_LINK} target="_blank" rel="noopener noreferrer" className="text-[#edbb23] font-semibold">Roobet</a>{" "}
            with code BROER supports the community.
          </p>
        </div>

        <p className="text-center text-[#8f88b8] text-sm mt-10">
          © {new Date().getFullYear()} BROER. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
